<div
  class="fixed-top ZI"
  [ngClass]="CompanyName == 'AU' && IsMobile ? 'd-none' : ''">
  <nav
    id="MainNAV"
    class="navbar Nav_IFA"
    [ngClass]="!IsMobile ? 'BoxShadow' : ''">
    <a
      class="navbar-brand LogoAnchorClass logo1 d-flex align-items-center"
      routerLinkActive="active">
      <!-- routerLink='/dashboard' routerLinkActive='active' [routerLink]='OnClickLogoUrl' -->
      <img
        alt="N/A"
        id="CompanyLogo"
        *ngIf="CompanyName == 'IFA' && !IsMobile"
        [src]="CompanyLogo" />
      <!-- <Script Language='Javascript'>

        document.write(unescape('%3C%64%69%76%20%64%69%72%3D%22%6C%74%72%22%20%73%74%79%6C%65%3D%22%74%65%78%74%2D%61%6C%69%67%6E%3A%20%6C%65%66%74%3B%22%20%74%72%62%69%64%69%3D%22%6F%6E%22%3E%0D%0A%3C%74%61%62%6C%65%20%62%6F%72%64%65%72%3D%22%31%22%20%63%65%6C%6C%70%61%64%64%69%6E%67%3D%22%30%22%20%63%65%6C%6C%73%70%61%63%69%6E%67%3D%22%30%22%20%73%74%79%6C%65%3D%22%77%69%64%74%68%3A%20%33%30%30%70%78%3B%22%3E%3C%74%62%6F%64%79%3E%0D%0A%3C%74%72%3E%3C%61%20%68%72%65%66%3D%22%68%74%74%70%3A%2F%2F%77%77%77%2E%69%6E%64%69%61%6E%2D%73%68%61%72%65%2D%74%69%70%73%2E%63%6F%6D%2F%22%3E%49%6E%64%69%61%6E%2D%53%68%61%72%65%2D%54%69%70%73%2E%43%6F%6D%3C%2F%61%3E%20%20%20%20%20%20%20%3C%74%64%20%76%61%6C%69%67%6E%3D%22%74%6F%70%22%20%77%69%64%74%68%3D%22%33%30%30%22%3E%3C%69%6D%67%20%61%6C%69%67%6E%3D%22%6C%65%66%74%22%20%61%6C%74%3D%22%4E%53%45%20%4E%69%66%74%79%20%49%6E%64%65%78%22%20%62%6F%72%64%65%72%3D%22%30%22%20%68%65%69%67%68%74%3D%22%31%35%30%22%20%73%72%63%3D%22%68%74%74%70%3A%2F%2F%77%77%77%2E%6D%6F%6E%65%79%63%6F%6E%74%72%6F%6C%2E%63%6F%6D%2F%67%64%2F%6D%61%69%6C%5F%69%6E%64%69%63%65%73%2E%70%68%70%22%20%73%74%79%6C%65%3D%22%62%61%63%6B%67%72%6F%75%6E%64%2D%69%6D%61%67%65%3A%20%6E%6F%6E%65%3B%20%62%6F%72%64%65%72%2D%62%6F%74%74%6F%6D%2D%77%69%64%74%68%3A%20%30%70%78%3B%20%62%6F%72%64%65%72%2D%6C%65%66%74%2D%77%69%64%74%68%3A%20%30%70%78%3B%20%62%6F%72%64%65%72%2D%72%69%67%68%74%2D%77%69%64%74%68%3A%20%30%70%78%3B%20%62%6F%72%64%65%72%2D%74%6F%70%2D%77%69%64%74%68%3A%20%30%70%78%3B%20%64%69%73%70%6C%61%79%3A%20%69%6E%6C%69%6E%65%3B%20%66%6C%6F%61%74%3A%20%6C%65%66%74%3B%20%6D%61%72%67%69%6E%3A%20%30%70%78%20%30%70%78%20%34%70%78%3B%20%70%61%64%64%69%6E%67%2D%6C%65%66%74%3A%20%30%70%78%3B%20%70%61%64%64%69%6E%67%2D%72%69%67%68%74%3A%20%30%70%78%3B%20%70%61%64%64%69%6E%67%2D%74%6F%70%3A%20%30%70%78%3B%22%20%77%69%64%74%68%3D%22%33%30%30%22%20%2F%3E%3C%2F%74%64%3E%20%20%20%20%20%3C%2F%74%72%3E%0D%0A%3C%2F%74%62%6F%64%79%3E%3C%2F%74%61%62%6C%65%3E%0D%0A%3C%2F%64%69%76%3E%0D%0A'));

        </Script> -->

      <!-- <img alt="N/A" id="CompanyLogo" *ngIf="CompanyName == 'IFA' && IsMobile" style="padding: 0 !important;" [src]="CompanyLogo" /> -->
      <!-- <div *ngIf="CompanyName == 'IFA' && IsMobile" class="mt-1">
        <span class="Welcome">Hi, {{FirstName}}</span>
          <div class="Good">Good to see you!</div>
      </div> -->

      <img
        alt="N/A"
        *ngIf="IsOptimoney && !IsMobile"
        class="logo_img"
        src="../../assets/images/IFA/OptimumLogo.svg"
        [style.width]="logoWidth"
        [style.height]="logoHeight" />
      <!-- <img alt="N/A" id="CompanyLogo" *ngIf="CompanyName == 'IFA' && !IsMobile" src="https://www.moneycontrol.com/gd/mail_indices.php" /> -->
    </a>
    <ul *ngIf="!IsMobile && !IsDummyLogin" class="navbar-nav CenterPosi">
      <li class="nav-item dropdown show">
        <a
          *ngIf="!IsDistributor && UserType != '1' && this.CompanyName != 'SPA'"
          class="nav-link"
          routerLink="/client-dashboard"
          routerLinkActive="active"
          id="client-dashboard">
          Dashboard
        </a>

        <a
          *ngIf="IsDistributor && UserType != '1' && IsIFA"
          class="nav-link"
          routerLink="/dashboard"
          routerLinkActive="active"
          id="dashboard">
          Dashboard
        </a>
      </li>
      <!-- <li class="nav-item" >
          <div *ngIf='UserType=="1" && RoleId == 3 ||  RoleId ==4 ||  RoleId ==5||  RoleId == 6' class="dropdown show">
            <a class="nav-link dropdown-toggle" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">TR Entry</a>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
              <a class="dropdown-item" routerLink="/mf-tr" routerLinkActive="active">MF</a>
              <a class="dropdown-item" routerLink="/pms-tr" routerLinkActive="active">PMS</a>
              <a class="dropdown-item" routerLink="/aif-tr" routerLinkActive="active">AIF</a>
            </div>
          </div>
        </li> -->
      <!-- IsDistributor && -->
      <li class="nav-item" *ngIf="IsBse && UserType != '3'">
        <a
          class="nav-link"
          routerLink="/clients"
          routerLinkActive="active"
          id="clients">
          Clients
        </a>
      </li>
      <!-- <li class="nav-item" *ngIf='!IsBse && UserType!="3"'>
        <a class="nav-link" routerLink='/nse-client' routerLinkActive='active'>Clients</a>
      </li> -->

      <!-- <li class="nav-item" *ngIf='IsDistributor && IsIFA'>
          <a class="nav-link" routerLink='/clients' routerLinkActive='active'>IFA Clients</a>
        </li> -->
      <li class="nav-item" *ngIf="IsBse" id="Id_Transaction">
        <a
          class="nav-link"
          routerLink="/transaction/lumpsum"
          routerLinkActive="active"
          id="transaction">
          Transact
        </a>
      </li>
      <!-- <li class="nav-item" *ngIf='!IsBse' id="Id_Transaction">
        <a class="nav-link" routerLink="/transact/lumpsum" routerLinkActive="active">Transact</a>
      </li> -->
      <li class="nav-item" *ngIf="IsBse">
        <a
          class="nav-link"
          routerLink="/explore-funds"
          routerLinkActive="active"
          id="explore-funds">
          Explore Funds
        </a>
      </li>
      <!-- <li class="nav-item" *ngIf='!IsBse'>
        <a class="nav-link" routerLink="/explore-funds-n" routerLinkActive="active">Explore Funds</a>
      </li> -->
      <!-- <li class="nav-item"  id="Id_Reports">
        *ngIf='IsOther && OFSClient==4'
        <a class="nav-link" routerLink="/reports/allocation-report" routerLinkActive="active">Performance</a>
      </li>-->
      <li class="nav-item" id="Id_Reports">
        <!-- *ngIf='IsOther && OFSClient!=4' -->
        <a
          class="nav-link"
          routerLink="/reports/allocation-report"
          routerLinkActive="active"
          id="reports">
          Reports
        </a>
      </li>
      <!-- <li class="nav-item" *ngIf='IsOther && OFSClient==4'>
        <a class="nav-link" routerLink="/calculators" routerLinkActive="active">Goal Based investments</a>
      </li> -->
      <li class="nav-item" *ngIf="IsOther && OFSClient != 4">
        <a
          class="nav-link"
          routerLink="/calculators"
          routerLinkActive="active"
          id="calculators">
          Calculators
        </a>
      </li>
      <!-- <li class="nav-item" *ngIf="IsOther && OFSClient!=4"> -->
      <li
        class="nav-item"
        *ngIf="
          IsOther && OFSClient != 4 && UserType != '3' && CompanyName == 'IFA'
        "
        id="Id_ValueAdds">
        <a
          class="nav-link"
          routerLink="/value-add-service/scheme-returns"
          id="value-add-service">
          Resources
        </a>
      </li>
    </ul>

    <ul *ngIf="!IsDummyLogin" class="navbar-nav m-0 ml-auto bg-white">
      <div (mouseleave)="IsMyDownloadOpen = false">
        <li
          *ngIf="CompanyName == 'IFA' && !IsMobile && UserType == '3'"
          class="nav-item MyAccountMenu mr-2"
          style="background-color: #f5f2fa; border-color: #f5f2fa">
          <a class="nav-link AncMyAcc" (mouseenter)="toggleDownload()">
            <span
              *ngIf="!IsMobile"
              style="
                font-family: var(--font-family-medium);
                color: #7c51b3 !important;
                font-weight: 100;
              ">
              Download App
              <i class="fa fa-angle-down"></i></span>
          </a>
        </li>
        <div
          (mouseleave)="IsMyDownloadOpen = false"
          [ngClass]="IsMyDownloadOpen ? 'd-block' : 'd-none'"
          [@openClose]="IsMyDownloadOpen ? 'open' : 'closed'"
          class="MyImportantOuter"
          style="right: 128px !important">
          <div *ngIf="!IsOptimoney">
            <img
              style="height: 150px !important"
              class="img-fluid"
              alt="Optimum mobile app showcase"
              [src]="UploadedQR" />
          </div>
          <!-- <div *ngIf="IsOptimoney">
            <img style="height:150px !important;" class="img-fluid" alt="Optimum mobile app showcase" [src]="UploadedQR" />
           </div> -->

          <a
            *ngIf="!IsOptimoney"
            [href]="DownloadLink"
            target="_blank"
            class="CursorPointer MyImaportantNavLink"
            style="color: #7c51b3 !important; font-weight: 100">
            <img
              style="width: auto; height: 44px !important"
              src="../../assets/images/img/MobileAppDownload.png"
              class="MobilAppimg" />
          </a>

          <a
            *ngIf="IsOptimoney && !IsOptiwealth"
            href="https://play.google.com/store/apps/details?id=com.optimum.client"
            target="_blank"
            class="CursorPointer MyImaportantNavLink"
            style="color: #7c51b3 !important; font-weight: 100">
            <img
              style="width: auto; height: 49px !important"
              src="../../assets/images/img/MobileAppDownload.png"
              class="MobilAppimg" />
          </a>

          <a
            *ngIf="IsOptimoney && IsOptiwealth"
            href=" https://play.google.com/store/apps/details?id=com.ofspl.financeapp"
            target="_blank"
            class="CursorPointer MyImaportantNavLink"
            style="color: #7c51b3 !important; font-weight: 100">
            <img
              style="width: auto; height: 49px !important"
              src="../../assets/images/img/MobileAppDownload.png"
              class="MobilAppimg" />
          </a>

          <p></p>
          <a
            *ngIf="IsOptimoney && !IsOptiwealth"
            href="https://apps.apple.com/in/app/optimoney-mutual-funds-app/id6470476406"
            target="_blank"
            class="CursorPointer MyImaportantNavLink"
            style="color: #7c51b3 !important; font-weight: 100">
            <img
              style="
                width: auto;
                height: 55px !important;
                /*padding: 2px 0px 2px 9px;*/
              "
              src="../../assets/images/img/ios-icon.svg"
              class="MobilAppimg" />
          </a>
          <a
            *ngIf="IsOptimoney && IsOptiwealth"
            href="https://apps.apple.com/in/app/optiwealth/id6743156447"
            target="_blank"
            class="CursorPointer MyImaportantNavLink"
            style="color: #7c51b3 !important; font-weight: 100">
            <img
              style="
                width: auto;
                height: 55px !important;
               /* padding: 2px 0px 2px 9px;*/
              "
              src="../../assets/images/img/ios-icon.svg"
              class="MobilAppimg" />
          </a>
        </div>
      </div>

      <!-- <li *ngIf="!IsMobile && UserType != '3'" class="nav-item MyAccountMenu border-0 mr-2" >
        <a *ngIf="!IsOptimoney" href="https://drive.google.com/file/d/1nvrKEnykANImcG6S7P25lzQg6y1ZrHP-/view?usp=sharing" target="_blank" class="CursorPointer nav-link" style="color: #7c51b3 !important; font-weight: 100;">Update Notes</a>
        <a *ngIf="IsOptimoney" href="https://drive.google.com/file/d/1aA3LMX8YvLOt8qzsikUB3vXzOLrbKc-l/view?usp=sharing" target="_blank" class="CursorPointer nav-link" style="color: #7c51b3 !important; font-weight: 100;">Update Notes</a>
      </li> -->
      <!-- added by adarsh 20052024 (mouseover)="toggleMyImportant()"-->
      <div (mouseleave)="IsMyImportantOpen = false">
        <li
          *ngIf="CompanyName == 'IFA' && !IsMobile && UserType != '3'"
          class="nav-item MyAccountMenu mr-2"
          style="background-color: #f5f2fa; border-color: #f5f2fa">
          <a class="nav-link AncMyAcc" (mouseenter)="IsMyImportantOpen = true">
            <span
              *ngIf="!IsMobile"
              style="
                font-family: var(--font-family-medium);
                color: #7c51b3 !important;
                font-weight: 100;
              ">
              Bookmarks
              <i class="fa fa-angle-down"></i></span>
          </a>
        </li>
        <!-- Added by adarsh20/05/2024 showImportantLinks (mouseleave)="toggleMyImportant()"-->
        <div
          (mouseleave)="IsMyImportantOpen = false"
          [ngClass]="IsMyImportantOpen ? 'd-block' : 'd-none'"
          [@openClose]="IsMyImportantOpen ? 'open' : 'closed'"
          class="MyImportantOuter">
          <!-- <a *ngIf="!IsOptimoney" href="https://drive.google.com/file/d/1nvrKEnykANImcG6S7P25lzQg6y1ZrHP-/view?usp=sharing" target="_blank" class="CursorPointer MyImaportantNavLink d-flex" style="color: #7c51b3 !important; font-weight: 100;">New Version Release Notes</a>
<a *ngIf="IsOptimoney" href="https://drive.google.com/file/d/1aA3LMX8YvLOt8qzsikUB3vXzOLrbKc-l/view?usp=sharing" target="_blank" class="CursorPointer MyImaportantNavLink d-flex" style="color: #7c51b3 !important; font-weight: 100;">New Version Release Notes</a>

<a *ngIf="!IsOptimoney" href="https://drive.google.com/file/d/1zA0Fvl6wmQdHu6A5NCAR1Sfovc2CB2ou/view?usp=sharing" target="_blank" class="CursorPointer MyImaportantNavLink d-flex" style="color: #4084F3 !important; font-weight: 100;">User Guide</a>
<a *ngIf="IsOptimoney" href="https://drive.google.com/file/d/1zA0Fvl6wmQdHu6A5NCAR1Sfovc2CB2ou/view?usp=sharing" target="_blank" class="CursorPointer MyImaportantNavLink d-flex" style="color: #4084F3 !important; font-weight: 100;">User Guide</a>


<a   href=" https://drive.google.com/file/d/1OcfKom6sRcB3YjxdcHxqMiCsHJdCkIwp/view?usp=sharing" target="_blank" class="CursorPointer MyImaportantNavLink d-flex" style="color: #4084F3 !important; font-weight: 100;" >Client Onboarding  (UCC) Tutorial</a> -->
          <a
            [href]="ReleaseNoteLink"
            target="_blank"
            class="CursorPointer MyImaportantNavLink d-flex text-center"
            style="color: #7c51b3 !important; font-weight: 100">
            New Version Release Notes
          </a>
          <a
            [href]="UserGuideLink"
            target="_blank"
            class="CursorPointer MyImaportantNavLink d-flex"
            style="color: #4084f3 !important; font-weight: 100">
            User Guide
          </a>
          <a
            [href]="ClientOnboardUCCLink"
            target="_blank"
            class="CursorPointer MyImaportantNavLink d-flex"
            style="color: #4084f3 !important; font-weight: 100">
            Client Onboarding (UCC) Tutorial
          </a>

          <p></p>
          <a
            href="https://www.camskra.com/cams-e-kyc"
            target="_blank"
            class="CursorPointer MyImaportantNavLink d-flex"
            style="font-weight: 100">
            CAMS - Investor eKYC
          </a>
          <a
            href="https://digital.camsonline.com/kycmodification"
            target="_blank"
            class="CursorPointer MyImaportantNavLink d-flex"
            style="font-weight: 100">
            CAMS - Investor KYC Modification
          </a>
          <a
            href=" 	https://www.camsonline.com/Investors/Statements/Consolidated-Account-Statement"
            target="_blank"
            class="CursorPointer MyImaportantNavLink d-flex"
            style="font-weight: 100">
            CAMS - Investor CAS
          </a>
          <a
            href=" 	https://digital.camsonline.com/changeofnomination"
            target="_blank"
            class="CursorPointer MyImaportantNavLink d-flex"
            style="font-weight: 100">
            CAMS - Nominee Opt-In / Opt-Out
          </a>
          <a
            href=" 	https://www.camsonline.com/Distributors/Service-Requests/Distributor-Mailback-Services/Request-Mailback"
            target="_blank"
            class="CursorPointer MyImaportantNavLink d-flex"
            style="font-weight: 100">
            CAMS - MFD Mailback Services
          </a>

          <p></p>
          <a
            href=" 	https://mfs.kfintech.com/investor/General/ConsolidatedAccountStatement"
            target="_blank"
            class="CursorPointer MyImaportantNavLink d-flex"
            style="font-weight: 100">
            kFintech - Investor CAS
          </a>
          <a
            href=" 	https://mfs.kfintech.com/mfs/distributor/distributor_Login.aspx"
            target="_blank"
            class="CursorPointer MyImaportantNavLink d-flex"
            style="font-weight: 100">
            kFintech - MFD Mailback Services
          </a>
          <p></p>
          <a
            href=" 	https://www.amfiindia.com/research-information/aum-data"
            target="_blank"
            class="CursorPointer MyImaportantNavLink d-flex"
            style="font-weight: 100">
            AMFI - AUM Data
          </a>
          <a
            href=" 	https://www.amfiindia.com/research-information/amfi-quarterlydata"
            target="_blank"
            class="CursorPointer MyImaportantNavLink d-flex"
            style="font-weight: 100">
            AMFI - AUM Quarterly data
          </a>
          <a
            href=" 	https://www.amfiindia.com/net-asset-value"
            target="_blank"
            class="CursorPointer MyImaportantNavLink d-flex"
            style="font-weight: 100">
            AMFI - Current NAV
          </a>
          <a
            href=" 	https://www.amfiindia.com/Themes/Theme1/downloads/AMFI_GUIDANCE_ON_MFD_NOMENCLATURE.pdf"
            target="_blank"
            class="CursorPointer MyImaportantNavLink d-flex"
            style="font-weight: 100">
            AMFI - Guide on MFD Nomenclature
          </a>
          <a
            href=" 	https://www.amfiindia.com/nav-history-download"
            target="_blank"
            class="CursorPointer MyImaportantNavLink d-flex"
            style="font-weight: 100">
            AMFI - Historical NAV
          </a>
          <a
            href=" 	https://www.amfiindia.com/new-fund-offer"
            target="_blank"
            class="CursorPointer MyImaportantNavLink d-flex"
            style="font-weight: 100">
            AMFI - NFO
          </a>
          <p></p>
          <a
            href=" 	https://bsestarmf.in/index.aspx	"
            target="_blank"
            class="CursorPointer MyImaportantNavLink d-flex"
            style="font-weight: 100">
            BSE StAR MF Platform
          </a>
          <a
            href=" 	https://www.cvlkra.com/Default.aspx"
            target="_blank"
            class="CursorPointer MyImaportantNavLink d-flex"
            style="font-weight: 100">
            CVLKRA - KYC Check
          </a>
          <a
            href="https://validate.cvlindia.com/CVLKRAVerification_V1/"
            target="_blank"
            class="CursorPointer MyImaportantNavLink d-flex"
            style="font-weight: 100">
            CVLKRA - KYC Validation
          </a>
        </div>

        <!-- Till here -->
      </div>

      <!-- <li *ngIf="CompanyName == 'IFA' && !IsMobile && UserType != '3'"  class="nav-item dropdown MyAccountMenu mr-2" style="background-color: #f5f2fa; border-color: #f5f2fa;">
  <a class="nav-link AncMyAcc dropdown-toggle" id="defaultDropdown" data-toggle="dropdown" data-auto-close="true"
          aria-expanded="false" style=" color: #7c51b3 !important;font-weight: 100;">  Important <i class="fa fa-angle-down"></i></a>
<ul class="dropdown-menu" aria-labelledby="defaultDropdown">
<li><a *ngIf="!IsOptimoney" href="https://drive.google.com/file/d/1nvrKEnykANImcG6S7P25lzQg6y1ZrHP-/view?usp=sharing" target="_blank" class="CursorPointer MyImaportantNavLink dropdown-item" style="color: #7c51b3 !important; font-weight: 100;">New Version Release Notes</a></li>
<li><a *ngIf="IsOptimoney" href="https://drive.google.com/file/d/1aA3LMX8YvLOt8qzsikUB3vXzOLrbKc-l/view?usp=sharing" target="_blank" class="CursorPointer MyImaportantNavLink dropdown-item" style="color: #7c51b3 !important; font-weight: 100;">New Version Release Notes</a></li>

<li><a   href=" https://drive.google.com/file/d/1OcfKom6sRcB3YjxdcHxqMiCsHJdCkIwp/view?usp=sharing" target="_blank" class="CursorPointer MyImaportantNavLink dropdown-item" style="color: #4084F3 !important; font-weight: 100;" >Client Onboarding  (UCC) Tutorial</a></li>
<p></p>
<li><a   href="https://www.camsonline.com/Distributors/Service-Requests/Distributor-Mailback-Services/Request-Mailback" target="_blank" class="CursorPointer MyImaportantNavLink dropdown-item" style=" font-weight: 100;" >	CAMS - MFD Mailback Services	</a></li>
<li><a   href="https://www.camsonline.com/Investors/Statements/Consolidated-Account-Statement" target="_blank" class="CursorPointer MyImaportantNavLink dropdown-item" style=" font-weight: 100;" >	CAMS - Investor CAS	</a></li>
<li><a   href="https://digital.camsonline.com/kycmodification" target="_blank" class="CursorPointer MyImaportantNavLink dropdown-item" style=" font-weight: 100;" >	CAMS - Investor KYC Modification	</a></li>
<li><a   href="https://digital.camsonline.com/changeofnomination" target="_blank" class="CursorPointer MyImaportantNavLink dropdown-item" style="color:black !important; font-weight: 100;" >	CAMS - Nominee Opt-In / Opt-Out	</a></li>
<p></p>
<li><a   href="https://mfs.kfintech.com/mfs/distributor/distributor_Login.aspx" target="_blank" class="CursorPointer MyImaportantNavLink dropdown-item" style=" font-weight: 100;" >	kFintech - MFD Mailback Services	</a></li>
<li><a   href="https://mfs.kfintech.com/investor/General/ConsolidatedAccountStatement" target="_blank" class="CursorPointer MyImaportantNavLink dropdown-item" style=" font-weight: 100;" >	kFintech - Investor CAS	</a></li>
<p></p>
<li><a   href="https://www.amfiindia.com/research-information/aum-data" target="_blank" class="CursorPointer MyImaportantNavLink dropdown-item" style=" font-weight: 100;" >	AMFI - AUM Data	</a></li>
<li><a   href="https://www.amfiindia.com/research-information/amfi-quarterlydata" target="_blank" class="CursorPointer MyImaportantNavLink dropdown-item" style=" font-weight: 100;" >	AMFI - AUM Quarterly data	</a></li>
<li><a   href="https://www.amfiindia.com/net-asset-value" target="_blank" class="CursorPointer MyImaportantNavLink dropdown-item" style=" font-weight: 100;" >	AMFI - Current NAV	</a></li>
<li><a   href="https://www.amfiindia.com/Themes/Theme1/downloads/AMFI_GUIDANCE_ON_MFD_NOMENCLATURE.pdf" target="_blank" class="CursorPointer MyImaportantNavLink dropdown-item" style=" font-weight: 100;" >	AMFI - Guide on MFD Nomenclature	</a></li>
<li><a   href="https://www.amfiindia.com/nav-history-download" target="_blank" class="CursorPointer MyImaportantNavLink dropdown-item" style=" font-weight: 100;" >	AMFI - Historical NAV	</a></li>
<li><a   href="https://www.amfiindia.com/new-fund-offer" target="_blank" class="CursorPointer MyImaportantNavLink dropdown-item" style=" font-weight: 100;" >	AMFI - NFO	</a></li>
<p></p>
<li><a   href="https://bsestarmf.in/index.aspx	" target="_blank" class="CursorPointer MyImaportantNavLink dropdown-item" style="color: #7c51b3 !important; font-weight: 100;" >	BSE StAR MF Platform	</a></li>
<li><a   href="https://www.cvlkra.com/Default.aspx" target="_blank" class="CursorPointer MyImaportantNavLink dropdown-item" style=" color :black !important;font-weight: 100;" >CVLKRA - KYC Check</a></li>

</ul>
</li> -->
      <!-- till here -->
      <div (mouseleave)="IsMyAccountOpen = false">
        <li
          *ngIf="CompanyName == 'IFA' && !IsMobile"
          class="nav-item MyAccountMenu mr-2"
          style="background-color: #f5f5f5; border-color: #f5f5f5">
          <a class="nav-link AncMyAcc" (mouseenter)="toggleMyAccount()">
            <img
              alt="N/A"
              class="svg"
              src="../../assets/images/IFA/MyAccount_Header.svg" />
            <span *ngIf="!IsMobile">
              {{ FirstName.split(' ', 1) }}
              <i class="fa fa-angle-down"></i></span>
          </a>
        </li>
        <div
          (mouseleave)="IsMyAccountOpen = false"
          [ngClass]="IsMyAccountOpen ? 'd-block' : 'd-none'"
          [@openClose]="IsMyAccountOpen ? 'open' : 'closed'"
          class="MyAccountOuter">
          <p *ngIf="IsDistributor" class="">
            <img
              alt="N/A"
              src="../../assets/images/IFA/CompanyName.svg"
              class="MyAccountImg svg" />
            {{ ContactPerFName }}
          </p>
          <p>
            <img
              alt="N/A"
              src="../../assets/images/IFA/Name.svg"
              class="MyAccountImg svg" />
            {{ FirstName }}
          </p>
          <p *ngIf="IsEmployee">
            <img
              alt="N/A"
              src="../../assets/images/IFA/EUINNumber.svg"
              class="MyAccountImg svg" />
            {{ EmpEUINNO }}
          </p>
          <p *ngIf="IsEmployee">
            <img
              alt="N/A"
              src="../../assets/images/IFA/Calender.svg"
              class="MyAccountImg svg" />
            {{ EmpEUINEndDate }}
          </p>
          <p *ngIf="IsDistributor">
            <img
              alt="N/A"
              src="../../assets/images/IFA/ARNNumber.svg"
              class="MyAccountImg svg" />
            {{ G_ARN }} &nbsp;&nbsp;
            <span class="d-flex ml-1">
              <img
                alt="N/A"
                src="../../assets/images/IFA/EUINNumber.svg"
                class="MyAccountImg svg" />
              {{ EUINNO }}
            </span>
          </p>
          <p *ngIf="!IsEmployee">
            <img
              alt="N/A"
              src="../../assets/images/IFA/Email.svg"
              class="MyAccountImg svg" />
            {{ EmailID }}
          </p>
          <p *ngIf="!IsEmployee">
            <img
              alt="N/A"
              src="../../assets/images/IFA/MobileNumber.svg"
              class="MyAccountImg svg" />
            {{ MobileNo }}
          </p>
          <p *ngIf="!IsEmployee && !IsIFA">
            <img
              alt="N/A"
              src="../../assets/images/IFA/Name.svg"
              class="MyAccountImg svg" />
            {{ RMName }}
          </p>
          <p *ngIf="!IsEmployee && !IsIFA">
            <img
              alt="N/A"
              src="../../assets/images/IFA/MobileNumber.svg"
              class="MyAccountImg svg" />
            {{ RMContact }}
          </p>
          <p
            *ngIf="!IsEmployee"
            class="SelectionActionClr CursorPointer"
            (click)="GoToAccount()">
            <img
              alt="N/A"
              src="../../assets/images/IFA/GoToAccount.svg"
              class="MyAccountImg svg" />
            Go To Account
          </p>
          <p class="ColorRed CursorPointer" (click)="LogOut()">
            <img
              alt="N/A"
              src="../../assets/images/IFA/Logout.svg"
              class="MyAccountImg svg" />
            Log Out
          </p>
        </div>
      </div>

      <!-- Hamburger Menu For IFA -->
      <li *ngIf="CompanyName == 'IFA' && IsMobile" class="nav-item mr-1">
        <a class="nav-link AncMyAcc" (click)="OpenToggleMenu()">
          <!-- <img alt="N/A" class="svg Hamb" src="../../assets/images/IFA/sidenav3-icon_IFA_revised.svg" /> -->
          <div class="HamCircle">
            {{ FirstName.substring(0, 1) }}
          </div>
        </a>
      </li>
    </ul>
  </nav>
  <div class="NavbarBg d-none"></div>
  <!-- <div class="AlertMsg">
    <div class="AlertMsg_1">Data Refresh and other maintenance activities in progress. Please avoid using the platform. (especially reports)</div>
    <div class="AlertMsg_1">Data Refresh and other maintenance activities in progress. Please avoid using the platform. (especially reports)</div>
  </div> -->
</div>

<!-- temproary bases hide nav bar for both login -->
<nav [ngClass]="IsMobile ? 'd-flex' : 'd-none'" class="navbar fixed-bottom">
  <ul class="navbar-nav m-0 w-100 text-center">
    <li
      class="nav-item"
      *ngIf="UserType == '2' && CompanyName == 'IFA'"
      routerLink="/dashboard"
      routerLinkActive="active">
      <img
        alt="N/A"
        src="../../assets/images/IFA/Dashboard_Mobile_IFA_New.svg"
        class="svg" />
      <a class="nav-link">Dashboard</a>
    </li>
    <li
      class="nav-item"
      *ngIf="UserType == '3' && this.CompanyName == 'IFA'"
      routerLink="/client-dashboard"
      routerLinkActive="active">
      <img
        alt="N/A"
        src="../../assets/images/IFA/Dashboard_Mobile_IFA_New.svg"
        class="svg" />
      <a class="nav-link">Dashboard</a>
    </li>

    <li
      class="nav-item"
      routerLink="/transaction/lumpsum"
      routerLinkActive="active"
      *ngIf="IsBse">
      <img
        alt="N/A"
        src="../../assets/images/IFA/Transaction_Mobile.svg"
        class="svg" />
      <a class="nav-link">Transact</a>
    </li>

    <li
      class="nav-item d-none"
      routerLink="/reports/holding-report"
      routerLinkActive="active"
      *ngIf="IsOther && OFSClient != 4 && OFSClient != 11">
      <img
        alt="N/A"
        src="../../assets/images/IFA/ReportsIcon.svg"
        class="svg" />
      <a class="nav-link">Reports</a>
    </li>

    <li
      class="nav-item d-none"
      routerLink="/explore-funds"
      routerLinkActive="active"
      *ngIf="IsOther && OFSClient != 4 && OFSClient != 11">
      <img
        alt="N/A"
        src="../../assets/images/IFA/ExploreIcon.svg"
        class="svg" />
      <a class="nav-link">Explore MF</a>
    </li>
    <li
      class="nav-item"
      *ngIf="IsOther && CompanyName == 'IFA'"
      routerLink="/calculators"
      routerLinkActive="active">
      <img src="../../assets/images/IFA/CalculatorIcon.svg" class="svg" />
      <a class="nav-link">Calculators</a>
    </li>
  </ul>
</nav>
<!-- IFA Hamburger Menu-->
<div id="mySidenav" class="sidenav">
  <a href="javascript:void(0)" class="pt-0">
    <span class="closebtn" style="color: white !important" (click)="closeNav()">
      &times;
    </span>
  </a>
  <div
    style="
      display: block;
      padding: 0px 0px !important;
      margin: 0 auto;
      background-color: var(--primary-color) !important;
      height: 130px;
    ">
    <ul class="nav text-center ToggleMenuTopSection ">
      <!-- comment by adarsh 06022024<li>
            <a class="active show MenuTab" data-toggle="tab" href="#Menu">Menu</a>
        </li>
        <li>
            <a data-toggle="tab" href="#AccInfo">Account Info</a>
        </li> -->

      <!-- <img alt="N/A" class="svg Hamb" src="../../assets/images/IFA/sidenav3-icon_IFA_revised.svg" /> -->
      <div
        *ngIf="IsMobile == true"
        class="HamCircle"
        style="
        /* margin: 0px 0px 0px 48%;  */
        background-color: #ffffff !important">
        <span style="color: var(--primary-color) !important">
          {{ FirstName.substring(0, 1) }}
        </span>
      </div>

      <div
        style="
          font-size: 18px;
          color: white;
          font-family: 'InterMedium';
          /* width: 100% !important;
          text-align: center; */
          margin-top: 8px; 
        ">
        {{ FirstName }}
      </div>
    </ul>
  </div>
  <div class="tab-content TabContentData Padding_Toggle_IFA">
    <div id="Menu" class="tab-pane fade show active">
      <div>
        <a
          class="MenuLink"
          *ngIf="UserType == '2'"
          routerLink="/dashboard"
          routerLinkActive="active">
          <div class="ToggleMenu">
            <img
              alt="N/A"
              src="../../assets/images/IFA/Dashboard_Mobile_IFA.svg"
              class="svg" />
            <span>Dashboard</span>
          </div>
        </a>
        <a
          class="MenuLink"
          *ngIf="UserType == '3'"
          routerLink="/client-dashboard"
          routerLinkActive="active">
          <div class="ToggleMenu">
            <img
              alt="N/A"
              src="../../assets/images/IFA/Dashboard_Mobile_IFA.svg"
              class="svg" />
            <span>Dashboard</span>
          </div>
        </a>

        <a
          class="MenuLink"
          *ngIf="IsBse && UserType != '3' && OFSClient != 4"
          routerLink="/clients"
          routerLinkActive="active">
          <div class="ToggleMenu">
            <img
              alt="N/A"
              src="../../assets/images/IFA/ClientsIcon.svg"
              class="svg" />
            <span>Clients</span>
          </div>
        </a>

        <a
          class="MenuLink"
          routerLink="/transaction/lumpsum"
          routerLinkActive="active"
          *ngIf="IsBse">
          <div class="ToggleMenu">
            <img
              alt="N/A"
              src="../../assets/images/IFA/Transaction_Mobile_IFA.svg"
              class="svg" />
            <span>Transact</span>
          </div>
        </a>

        <a
          class="MenuLink"
          *ngIf="IsOther && OFSClient != 4 && OFSClient != 11"
          routerLink="/reports/holding-report"
          routerLinkActive="active">
          <div class="ToggleMenu">
            <img
              alt="N/A"
              src="../../assets/images/IFA/Reports_Mobile_IFA.svg"
              class="svg" />
            <span>Reports</span>
          </div>
        </a>
        <a
          class="MenuLink"
          routerLink="/explore-funds"
          routerLinkActive="active">
          <div class="ToggleMenu">
            <img
              alt="N/A"
              src="../../assets/images/IFA/ExploreFunds_IFA_New_flipped.svg"
              class="svg" />
            <span>Explore Funds</span>
          </div>
        </a>
        <a
          class="MenuLink"
          routerLink="/value-add-service/scheme-returns"
          routerLinkActive="active"
          *ngIf="
            IsOther && OFSClient != 4 && UserType != '3' && CompanyName == 'IFA'
          "
          id="Id_ValueAdds">
          <div class="ToggleMenu">
            <img
              alt="N/A"
              src="../../assets/images/IFA/Resources_Icon1.svg"
              class="svg" />
            <span>Resources</span>
          </div>
        </a>

        <!-- By pradnesh 28/07/2025 -->
        <!-- <a class="MenuLink">
          <div class="ToggleMenu">
            <img
              alt="N/A"
              src="../../assets/images/IFA/FocusedFundsIocn.svg"
              class="svg" />
            <span>Focused Funds</span>
          </div>
          <div>
            <span class="Csoon">Coming Soon</span>
          </div>
        </a>
        <a class="MenuLink">
          <div class="ToggleMenu">
            <img
              alt="N/A"
              src="../../assets/images/IFA/SaveTaxIcon2.svg"
              class="svg" />
            <span>Save Tax</span>
          </div>
          <div>
            <span class="Csoon">Coming Soon</span>
          </div>
        </a> -->

        <a
          class="MenuLink NoBtmBorder"
          *ngIf="IsOther && CompanyName == 'IFA'"
          routerLink="/calculators"
          routerLinkActive="active">
          <div class="ToggleMenu">
            <img
              alt="N/A"
              src="../../assets/images/IFA/carbon_calculator_IFA.svg"
              class="svg" />
            <span>Calculators</span>
          </div>
        </a>
        <!--<div>
         <a class="MenuLink" *ngIf='IsOther && CompanyName == "IFA"' a data-toggle="tab" href="#AccInfo">
          <div class="ToggleMenu"><img alt="N/A" src="../../assets/images/IFA/GoToAccount_IFA.svg" class="svg" />
            <span>Account Settings</span></div>
          </a>
        </div>-->
        <!-- <a class="MenuLink" >
        <div class="ToggleMenu"><img alt="N/A" src="../../assets/images/IFA/ShareApp_Icon2.svg" class="svg" />
        <span>Share App</span></div>
        <div>
          <span class="Csoon">Coming Soon</span>
        </div>
      </a> -->
        <!-- <a class="MenuLink" *ngIf="!IsOptimoney && UserType != '3' && IsMobile" href="https://drive.google.com/file/d/1nvrKEnykANImcG6S7P25lzQg6y1ZrHP-/view?usp=sharing" target="_blank">
        <div class="ToggleMenu"><img alt="N/A" href="https://drive.google.com/file/d/1aA3LMX8YvLOt8qzsikUB3vXzOLrbKc-l/view?usp=sharing" target="_blank" src="../../assets/images/IFA/UpdateNotes_Icon2.svg" class="svg" style="    margin-right: 10px;"/>
          <span class="SelectionActionClr">Update Notes</span></div>
        </a>
        <a class="MenuLink" *ngIf="IsOptimoney && UserType != '3' && IsMobile" >
          <div class="ToggleMenu"><img alt="N/A" src="../../assets/images/IFA/ReleaseNotes.svg" class="svg" />
            <span class="SelectionActionClr">Update Notes</span></div>
          </a>
      <a class="ColorRed CursorPointer MenuLink border-bottom-0" (click)="LogOut();">
        <div class="ToggleMenu" style="margin-left: 1px;"><img alt="N/A" src="../../assets/images/IFA/LogoutIcon.svg" class="svg" />
        <span>Logout</span></div>
      </a> -->
      </div>
    </div>
    <div id="AccInfo" class="tab-pane fade">
      <div class="" [ngClass]="IsMobile ? 'accsetting_div' : ''">
        <a
          *ngIf="IsDistributor"
          class=""
          [ngClass]="IsMobile ? 'a_padding' : ''">
          <p>
            <img
              alt="N/A"
              src="../../assets/images/IFA/CompanyName_IFA.svg"
              class="svg Info" />
            <span class="OverText">{{ ContactPerFName }}</span>
          </p>
        </a>
        <a class="" [ngClass]="IsMobile ? 'a_padding' : ''">
          <p>
            <img
              alt="N/A"
              src="../../assets/images/IFA/Name_IFA.svg"
              class="svg Info" />
            {{ FirstName }}
          </p>
        </a>
        <a
          *ngIf="IsDistributor"
          class=""
          [ngClass]="IsMobile ? 'a_padding' : ''">
          <p>
            <img
              alt="N/A"
              src="../../assets/images/IFA/ARNNumber_IFA.svg"
              class="svg Info" />
            {{ G_ARN }}
          </p>
        </a>
        <a
          *ngIf="IsDistributor"
          class=""
          [ngClass]="IsMobile ? 'a_padding' : ''">
          <p class="">
            <img
              alt="N/A"
              src="../../assets/images/IFA/EUINNumber_IFA.svg"
              class="svg Info" />
            {{ EUINNO }}
          </p>
        </a>
        <a *ngIf="!IsEmployee" class="" [ngClass]="IsMobile ? 'a_padding' : ''">
          <p>
            <img
              alt="N/A"
              src="../../assets/images/IFA/Email_IFA.svg"
              class="svg Info" />
            <span class="OverText">{{ EmailID }}</span>
          </p>
        </a>
        <a *ngIf="!IsEmployee" class="" [ngClass]="IsMobile ? 'a_padding' : ''">
          <p>
            <img
              alt="N/A"
              src="../../assets/images/IFA/MobileNumber_IFA.svg"
              class="svg Info" />
            {{ MobileNo }}
          </p>
        </a>
        <a
          *ngIf="UserType == '3'"
          class="SelectionActionClr"
          [ngClass]="IsMobile ? 'a_padding' : ''"
          routerLink="/DeleteAccount"
          routerLinkActive="active">
          <p class="SelectionActionClr">
            <i
              class="fa fa-trash"
              style="
                width: 18px;
                font-size: 21px;
                padding: 1px;
                height: 23px;
                margin-right: 10px;
              "></i>Delete Account
          </p>
        </a>

        <a
          *ngIf="!IsEmployee"
          class="CursorPointer mt-2 SelectionActionClr"
          (click)="GoToAccount()">
          <span class="CommonSubmitButton GoToAcBtn">Go To Account</span>
        </a>
        <!-- <a *ngIf="!IsEmployee" class="ColorGreen CursorPointer" (click)="GoToAccount();">
        <p class="ColorGreen"><img alt="N/A" src="../../assets/images/IFA/GoToAccount_IFA.svg" class="svg Info" />
          Go To Account</p>
        </a> -->
      </div>
    </div>
  </div>
  <div class="tab-content TabContentData Padding_Toggle_IFA">
    <div id="Menu2" class="tab-pane fade show active">
      <div>
        <span id="menu2_link" class="">
          <!-- <a class="MobMenuLink" *ngIf='IsOther && CompanyName == "IFA"'  data-toggle="tab" href="#AccInfo" (click)="AccSetting_click()">
        <div class="ToggleMenu"><img alt="N/A" src="../../assets/images/IFA/GoToAccount_IFA.svg" class="svg" />
          <span>Account Settings</span></div>
        </a> -->
          <a
            class="MobMenuLink NoBtmBorder"
            *ngIf="IsOther && CompanyName == 'IFA'"
            (click)="GoToAccount()">
            <div class="ToggleMenu">
              <img
                alt="N/A"
                src="../../assets/images/IFA/GoToAccount_IFA.svg"
                class="svg" />
              <span>Account Settings</span>
            </div>
          </a>
        </span>
        <span id="menu_link" class="d-none">
          <a
            class="MobMenuLink"
            *ngIf="IsOther && CompanyName == 'IFA'"
            (click)="showAllMenu()">
            <div id="menu_link" class="ToggleMenu">
              <span>Main menu</span>
            </div>
          </a>
        </span>
      </div>
    </div>
  </div>

  <div
    class="tab-content TabContentData Padding_Toggle_IFA"
    [ngClass]="IsMobile && IsAccSettingClick ? 'd-none' : ''">
    <div id="Menu3" class="tab-pane fade show active">
      <div>
        <a
          class="MenuLink"
          *ngIf="!IsOptimoney && UserType != '3' && IsMobile"
          href="https://drive.google.com/file/d/1nvrKEnykANImcG6S7P25lzQg6y1ZrHP-/view?usp=sharing"
          target="_blank">
          <div class="ToggleMenu">
            <img
              alt="N/A"
              href="https://drive.google.com/file/d/1aA3LMX8YvLOt8qzsikUB3vXzOLrbKc-l/view?usp=sharing"
              target="_blank"
              src="../../assets/images/IFA/UpdateNotes_Icon2.svg"
              class="svg"
              style="margin-right: 10px" />
            <span class="SelectionActionClr">New Version Release Notes</span>
          </div>
        </a>
        <a class="MenuLink" *ngIf="IsOptimoney && UserType != '3' && IsMobile">
          <div class="ToggleMenu">
            <img
              alt="N/A"
              src="../../assets/images/IFA/ReleaseNotes.svg"
              class="svg" />
            <span class="SelectionActionClr">New Version Release Notes</span>
          </div>
        </a>
        <a
          class="ColorRed CursorPointer MenuLink border-bottom-0"
          (click)="LogOut()">
          <div class="ToggleMenu" style="margin-left: 1px">
            <img
              alt="N/A"
              src="../../assets/images/IFA/LogoutIcon.svg"
              class="svg" />
            <span>Logout</span>
          </div>
        </a>
      </div>
    </div>
    <!-- <a class="Divider"></a> -->
  </div>

  <div
    class="tab-content TabContentData Padding_Toggle_IFA"
    style="background: #f1f3f4; padding: 2px 20px 40px 20px !important"
    [ngClass]="
      !HideAccountsetting && UserType == '3' && IsMobile ? 'd-block' : 'd-none'
    ">
    <div class="d-flex justify-content-start">
      <span style="margin: 2% 0% 0% 0%; color: #8696a0 !important; font-size: 11px;">ABOUT</span>
    </div>
    <div id="ToggleMenu4" class="tab-content TabContentData Padding_Toggle_IFA">
      <div id="Menu4" class="tab-pane fade show active">
        <div>
          <a class="MenuLink">
            <div class="ToggleMenu">
              <img
                alt="N/A"
                src="../../assets/images/IFA/CompanyName_IFA.svg"
                class="svg" />
              <span>{{ AppName }}</span>
            </div>
          </a>
          <a class="MenuLink">
            <div class="ToggleMenu">
              <img
                alt="N/A"
                src="../../assets/images/IFA/user.svg"
                class="svg" />
              <span>{{ SBName }}</span>
            </div>
          </a>
          <a class="MenuLink">
            <div class="ToggleMenu">
              <img
                alt="N/A"
                src="../../assets/images/IFA/phone.svg"
                class="svg" />
              <span>{{ SBMobile }}</span>
            </div>
          </a>
          <a class="MenuLink">
            <div class="ToggleMenu">
              <img
                alt="N/A"
                src="../../assets/images/IFA/Email.svg"
                class="svg" />
              <span>{{ SBEmail }}</span>
            </div>
          </a>

          <!-- <a class="MenuLink" *ngIf="UserType == '3' && IsMobile">
        <div>
          <span class="d-flex justify-content-start">ABOUT</span>
          <a><img alt="N/A" src="../../assets/images/IFA/CompanyName_IFA.svg"
            class="svg Info" /> {{AppName}}</a>
          <a><img alt="N/A" src="../../assets/images/IFA/CompanyName_IFA.svg"
            class="svg Info" /> {{SBName}}</a>
          <a><img alt="N/A" src="../../assets/images/IFA/MobileNumber_IFA.svg"
            class="svg Info" /> {{SBMobile}}</a>
          <a><img alt="N/A" src="../../assets/images/IFA/Email_IFA.svg" class="svg Info" />{{SBEmail}}</a>
        </div>
      </a> -->
        </div>
      </div>
      <!-- <a class="Divider"></a> -->
    </div>
    <div  class="d-flex justify-content-start" *ngIf="!IsOptimoney">
      <span style="margin: 6% 0% 0% 0%; color: #8696a0 !important">
        CONNECT WITH US
      </span>
    </div>
    <div
    id="ToggleMenu5"
      class="mainFooter-bottom tab-content TabContentData Padding_Toggle_IFA"
      [ngClass]="
        !IsOptimoney && UserType == '3' && IsMobile ? 'd-block' : 'd-none'
      ">
      <div class="feature contact-panel tab-pane fade show active">
        <ul class="MobMenuLink" style="padding: 20px 0px 20px !important">
          <li>
            <a
              [href]="WhatsAppLink"
              target="_blank"
              rel="nofollow noopener"
              title="WhatsApp">
              <img
                width="24"
                height="24"
                class="icon scaleAnimation"
                src="../../../assets/images/img/socialicons/WhatsApp-icon.svg"
                alt="WhatsApp" />
            </a>
          </li>

          <li>
            <a
              [href]="LinkedInLink"
              target="_blank"
              rel="nofollow noopener"
              title="linkedin">
              <img
                width="24"
                height="24"
                class="icon scaleAnimation"
                src="../../../assets/images/img/socialicons/linkedin-icon.svg"
                alt="linkedin" />
            </a>
          </li>
          <li>
            <a
              [href]="FacebookLink"
              target="_blank"
              rel="nofollow noopener"
              title="facebook">
              <img
                width="24"
                height="24"
                class="icon scaleAnimation"
                src="../../../assets/images/img/socialicons/facebook-icon.svg"
                alt="facebook" />
            </a>
          </li>
          <li>
            <a
              [href]="TwitterLink"
              target="_blank"
              rel="nofollow noopener"
              title="twitter">
              <img
                width="24"
                height="24"
                class="icon scaleAnimation"
                src="../../../assets/images/img/socialicons/twitter-icon.svg"
                alt="twitter" />
            </a>
          </li>
          <li>
            <a
              [href]="InstagramLink"
              target="_blank"
              rel="nofollow noopener"
              title="instagram">
              <img
                width="24"
                height="24"
                class="icon scaleAnimation"
                src="../../../../assets/images/img/socialicons/instagram-icon.svg"
                alt="instagram" />
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <span
    *ngIf="UserType != '1'"
    style="margin: 141px 0px 0px 0px; justify-content: center"
    class="ColorRed CursorPointer MenuLink border-bottom-0">
    <app-footer></app-footer>
  </span>
  <!-- IFA Hamburger Menu Ends-->

  <div class="modal" id="Delete" appDisabledRightClick>
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content AlertModalContentCls">
        <div class="modal-header AlertModalHeader">Important Message</div>
        <div id="MandateAlertModalContent" class="modal-body AlertModalBody">
          Are you sure you want to delete your account?
          <br />
          By deleting your account, all your data will be deleted from this app
          and you will not be able to log in to this App. Please note that your
          Mutual Investment Data can be accessed externally by visiting the
          respective Mutual Fund Asset Management Company's website.
        </div>
        <div class="modal-footer AlertModalFooter">
          <button
            type="button"
            data-dismiss="modal"
            class="CommonSecondaryButton CursorPointer"
            (click)="OnDelete()">
            Delete Account
          </button>
          <button
            type="button"
            data-dismiss="modal"
            class="CursorPointer"
            routerLink="/client-dashboard"
            routerLinkActive="active"
            (click)="closeNav()">
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal" id="SureDelete" appDisabledRightClick>
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content AlertModalContentCls">
        <div class="modal-header AlertModalHeader">Important Message</div>
        <div id="MandateAlertModalContent" class="modal-body AlertModalBody">
          Account Deletion Request placed successfully.
          <br />
          Our system will send you an email to complete the process.
        </div>
        <div class="modal-footer AlertModalFooter">
          <button
            type="button"
            data-dismiss="modal"
            class="CursorPointer"
            routerLink="/client-dashboard"
            routerLinkActive="active">
            Okay
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
